import { Box } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { useEffect, useState } from "react";
import MyIcon from "../Icon/MyIcon";

const popAnimation = keyframes`
    0% { transform: scale(1); }
    35% { transform: scale(1.28); }
    70% { transform: scale(1.08); }
    100% { transform: scale(1); }
`;

interface AnimatedReactionIconProps {
    src: string;
    alt: string;
    width?: number;
    height?: number;
    /** 클릭할 때마다 1씩 증가시켜 애니메이션을 재생 */
    pulseKey: number;
}

export default function AnimatedReactionIcon({
    src,
    alt,
    width = 20,
    height = 20,
    pulseKey,
}: AnimatedReactionIconProps) {
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (pulseKey === 0) return;

        setIsAnimating(true);
        const timer = setTimeout(() => setIsAnimating(false), 450);

        return () => clearTimeout(timer);
    }, [pulseKey]);

    return (
        <Box
            display={"inline-flex"}
            alignItems={"center"}
            justifyContent={"center"}
            width={`${width}px`}
            height={`${height}px`}
            flexShrink={0}
            animation={isAnimating ? `${popAnimation} 0.45s ease-out` : undefined}
        >
            <MyIcon src={src} alt={alt} width={width} height={height} />
        </Box>
    );
}
